import { render, staticRenderFns } from "./DirectReport.vue?vue&type=template&id=683072fa&scoped=true"
import script from "./DirectReport.vue?vue&type=script&lang=js"
export * from "./DirectReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683072fa",
  null
  
)

export default component.exports